import { useMutation } from '@tanstack/react-query';

import { type PointsGroup } from 'src/features/parkingManagement/types/pointsGroup.ts';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/points-group/:pointsGroupId/';

interface DTO {
    parkingId: string;
    pointsGroupId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, pointsGroupId, ...data }: DTO): Promise<PointsGroup> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, pointsGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeletePointsGroup };
